import { render } from "./AppShadowContent.vue?vue&type=template&id=12f7bb65&ts=true"
import script from "./AppShadowContent.vue?vue&type=script&lang=ts"
export * from "./AppShadowContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__